import { gql } from '@apollo/client';
import { agencyItemsFragment } from '../fragments/agencyItems';

export const getInitialItems = gql`
  query InitialItems {
    residences(limit: 4, sort: RANDOM) {
      id
      name
      price {
        perUnit
        total {
          minimum
          maximum
        }
        currency
      }
      address
      shortAddress
      deadline
      coverUrl
      path
      metroName
      companyName
    }
    agencies(limit: 16, sort: RANDOM) {
      items(limit: 1, sort: RANDOM) {
        ...agencyItemFields
      }
    }
  }
  ${agencyItemsFragment}
`;
